<script>
import { Overlay } from '../../'
import linreg from '../../stuff/linreg.js'

import Price from './price.js'

export default {
    name: 'LinearRegressionChannel',
    props: [
        'data', 'sub', 'tf'
    ],
    mixins: [Overlay],
    computed: {
        sett() {
            return this.$props.settings
        },
        price_line() {
            return 'priceLine' in this.sett ?
                this.sett.priceLine : true
        },
        risk_reward_ratio() {
            return this.sett.riskRewardRatio || 3
        },
        sma_length() {
            return this.sett.smaLength || 50
        },
        dc_length() {
            return this.sett.dcLength || 20
        },
        show_pending_target() {
            return this.sett.showPendingTarget || true
        },
        show_immediate_target() {
            return this.sett.showImmediateTarget || true
        },
        show_safe_target() {
            return this.sett.showSafeTarget || false
        },
        show_highlight_entry() {
            return this.sett.showHighlightEntry || true
        },
        default_font() {
            return '12px ' + this.$props.font.split('px').pop()
        },
        currency_symbol() {
            return this.sett.currency || '₹'
        },
        long_color() {
            return this.sett.longColor || 'rgba(99, 223, 137, 0.6)' // '#63df89'
        },
        short_color() {
            return this.sett.shortColor || 'rgba(255, 213, 129, 0.6)' // '#ffd581'
        },
        long_cover_color() {
            return this.sett.longCoverColor || 'rgba(252, 126, 47, 0.6)' // '#fc7e2f'
        },
        short_cover_color() {
            return this.sett.shortCoverColor || 'rgba(255, 107, 214, 0.6)' // '#ff6bd6'
        },
        label_color() {
            return this.sett.labelColor || 'rgba(75, 236, 249, 0.6)' // '#4BECF9'
        },
        upBarColor() {
            return this.sett.upBarColor || "rgb(38, 166, 154)"
        },
        downBarColor() {
            return this.sett.downBarColor || "rgb(239, 83, 80)"
        },
        pendingTargetColor() {
            return this.sett.pendingTargetColor || "rgb(92, 92, 92)"
        },
        marker_size() {
            return this.sett.markerSize || 5
        },
        show_label() {
            return this.sett.showLabel !== false
        },
        new_font() {
            return this.sett.font || this.default_font
        },
        current_trend() {
           return this.$props.trend || {}
        }
    },
    methods: {
        meta_info() {
            return {
                author: 'Mano',
                version: '1.0.0',
                desc: 'LinearRegressionChannel',
                preset: {
                    name: 'LinReg, $smaLength $dcLength $riskRewardRatio',
                    side: 'onchart',
                    settings: {
                        "smaLength": this.sma_length,
                        "dcLength": this.dc_length,
                        "riskRewardRatio": this.risk_reward_ratio,
                        "showImmediateTarget": this.show_immediate_target,
                        "showPendingTarget": this.show_pending_target,
                        "showSafeTarget": this.show_safe_target,
                        "showHighlightEntry": this.show_highlight_entry,
                        "z-index": -3
                    }
                }
            }
        },
        init() {
            this.price = new Price(this)
        },
        draw(ctx) {
            ctx.lineWidth = this.line_width
            //ctx.strokeStyle = this.color
            //ctx.beginPath()
            const length = 100
            const devlen = 2
            const layout = this.$props.layout
            const i = this.data_index
            const data = this.$props.sub.full_data

            let sum = 0
            for (var k = data.length - length; k >= 0; k--) {
                sum = sum + data[k][4]
            }

            let mid = sum / length
            let slope = linreg(data, length, 0) - linreg(data, length, 1)
            let intercept  = mid - slope * Math.floor(length / 2) + ((1 - (length % 2)) / 2) * slope
            let endy =  intercept  + slope * (length - 1)
            let dev = 0.0
            for (var x = 0; x < length - 1; x++) {
                dev = dev + Math.pow(data[x][4] - (slope * (length - x) + intercept), 2)
            }
            dev = Math.sqrt(dev/length)

            let x1 = i - (length - 1)
            let y1 = intercept + dev * devlen * -1
            let x2 = i
            let y2 =  endy + dev * devlen * -1

            ctx.beginPath()
            let _x1 = layout.t2screen(x1)
            let _y1 = layout.$2screen(y1)
            let _x2 = layout.t2screen(x2)
            let _y2 = layout.$2screen(y2)
            ctx.moveTo(_x1, _y1)
            ctx.lineTo(_x2, _y2)

            ctx.stroke()
        },

        draw_label(ctx, x, y, labelText) {
            ctx.fillStyle = this.label_color
            ctx.font = this.new_font
            ctx.textAlign = 'center'
            ctx.fillText(labelText, x, y)
        },
        use_for() {
            return ['LinearRegressionChannel']
        },
        hexToRGBA(inputHex, opacity) {
            const hex = inputHex.replace("#", "")
            if (inputHex.indexOf("#") > -1 && (hex.length === 3 || hex.length === 6)) {

                const multiplier = (hex.length === 3) ? 1 : 2

                const r = parseInt(hex.substring(0, 1 * multiplier), 16)
                const g = parseInt(hex.substring(1 * multiplier, 2 * multiplier), 16)
                const b = parseInt(hex.substring(2 * multiplier, 3 * multiplier), 16)

                const result = `rgba(${ r }, ${ g }, ${ b }, ${ opacity })`

                return result
            }
            return inputHex
        }
    }
}
</script>
